import React, { useEffect, useState } from "react";

function Counter(props) {
  const [CounterValue, setCounterValue] = useState("");
  const [second, setSecond] = useState("00");
  const [minute, setMinute] = useState(0);
  const [hour, setHour] = useState(0);
  const [day, setDay] = useState(0);
  const setTime = props.endDate;

  useEffect(() => {
    function counter() {
      timeBetweenDates(setTime);
      setCounterValue(CounterValue + 1);
    }

    function timeBetweenDates(toDate) {
      var now = new Date();

      var difference = setTime - parseInt(now.getTime() / 1000);
      if (difference <= 0) {
        // Timer done
        clearInterval();
      } else {
        var seconds = Math.floor(difference);
        var minutes = Math.floor(difference / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);

        hours %= 24;
        minutes %= 60;
        seconds %= 60;

        setSecond(seconds);
        setMinute(minutes);
        setHour(hours);
        setDay(days);
      }
    }
    setTimeout(() => {
      counter();
    }, 1000);
  }, [CounterValue]);

  return (
    <>
      {!props.isEnded ? (
        <div
          className="mt-5"
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "center",
            gap: "15px",
          }}
        >
          <div className="border-2 min-w-[77px] max-w-[77px] px-2 text-center py-2 border-[#041562] rounded-md">
            <p className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[22px] text-[16px]">
              {day}
            </p>
            <p className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] text-[13px]">
              Days
            </p>
          </div>
          <div className="border-2 min-w-[77px] max-w-[77px] px-2 text-center py-2 border-[#041562] rounded-md">
            <p className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[22px] text-[16px]">
              {hour}
            </p>
            <p className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] text-[13px]">
              Hour
            </p>
          </div>
          <div className="border-2 min-w-[77px] max-w-[77px] px-2 text-center py-2 border-[#041562] rounded-md">
            <p className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[22px] text-[16px]">
              {minute}
            </p>
            <p className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] text-[13px]">
              Min
            </p>
          </div>
          <div className="border-2 min-w-[77px] max-w-[77px] px-2 text-center py-2 border-[#041562] rounded-md">
            <p className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[22px] text-[16px]">
              {second}
            </p>
            <p className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] text-[13px]">
              Sec
            </p>
          </div>
        </div>
      ) : (
        <div className="flex justify-between my-[20px]">
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="font-bold ">{0}</span>
            <span className="text-[9px]">Days</span>
          </div>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="font-bold ">{0}</span>
            <span className="text-[9px]">Hours</span>
          </div>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="font-bold ">{0}</span>
            <span className="text-[9px]">Minute</span>
          </div>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="font-bold ">{0}</span>
            <span className="text-[9px]">Seconds</span>
          </div>
        </div>
      )}
    </>
  );
}

export default Counter;
